(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ar-crosssell-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ar-crosssell')) {
    customElements.define('ar-crosssell', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.base = this.querySelector('[data-base]');
        this.button = this.querySelector('[data-add]');
        this.wrapper = this.closest('[data-product-wrapper]') || this.parentElement;
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.addEventListener('change', () => this.update(), options);
        this.wrapper.addEventListener('input', () => this.update(), options);
        this.wrapper.addEventListener('change', () => setTimeout(() => this.update(), 0), options);
        this.wrapper.addEventListener('variant-change', event => {
          this.update();
        }, { ...options, capture: true });
        this.button.addEventListener('click', () => this.add(), options);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.bound = false; }
      form() { return this.wrapper.querySelector('form[action*="/cart/add"]'); }
      update() {
        const form = this.form();
        const id = form?.querySelector('variant-selection')?.getAttribute('variant') || form?.querySelector('[name="id"]')?.value || this.base.dataset.variant;
        const variant = this.variants.find(item => String(item.id) === id);
        this.currentVariant = variant;
        this.quantity = Math.max(1, parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
        this.base.checked = !!variant?.available;
        this.querySelector('[data-base-price]').textContent = this.format.format((variant?.price || 0) * this.quantity / 100);
        this.querySelector('[data-base-quantity]').textContent = this.quantity > 1 ? '× ' + this.quantity : '';
        let total = variant?.available ? variant.price * this.quantity : 0;
        this.querySelectorAll('[data-partner]:checked').forEach(item => { total += Number(item.dataset.price); });
        this.querySelector('[data-total]').textContent = this.format.format(total / 100);
        this.button.disabled = this.busy || !variant?.available;
      }
      async add() {
        this.update();
        if (this.busy || !this.currentVariant?.available) return;
        const form = this.form();
        if (form && !form.reportValidity()) return;
        const base = { id: this.currentVariant.id, quantity: this.quantity };
        if (form) {
          const data = new FormData(form);
          const properties = {};
          for (const [key, value] of data.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string') properties[match[1]] = value;
          }
          if (Object.keys(properties).length) base.properties = properties;
          if (data.get('selling_plan')) base.selling_plan = data.get('selling_plan');
        }
        const items = [base];
        this.querySelectorAll('[data-partner]:checked').forEach(item => items.push({ id: Number(item.dataset.variant), quantity: 1 }));
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.button.dataset.busy;
        const errorElement = this.querySelector('[data-error-message]');
        errorElement.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          errorElement.textContent = error.message || this.dataset.error;
          errorElement.hidden = false;
          this.busy = false;
          this.button.textContent = this.button.dataset.label;
          this.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ar-muster-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ar-product-description')) {
  customElements.define('ar-product-description', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const box = this.querySelector('.ar-v1-description-body');
      const button = this.querySelector('button');
      if (!box || !button) return;
      let expanded = false;
      const measure = () => {
        const limit = parseFloat(getComputedStyle(box).getPropertyValue('--ar-description-height')) || 420;
        const long = box.scrollHeight > limit + 24;
        box.classList.toggle('is-clamped', long && !expanded);
        button.hidden = !long && !expanded;
      };
      button.onclick = () => {
        expanded = !expanded;
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
        measure();
        if (!expanded && box.getBoundingClientRect().top < 140) box.scrollIntoView({block: 'start'});
      };
      this.observer = new ResizeObserver(measure);
      this.observer.observe(box.firstElementChild);
      measure();
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ar-product-legacy"] && !Shopify.designMode) return;
  try {
    (() => {
  const group = () => {
    document.querySelectorAll('[data-ar-legacy-sections]').forEach((panel) => {
      const target = panel.querySelector('[data-ar-legacy-content]');
      const ids = panel.dataset.arLegacySections.split('|');
      const sections = [...document.querySelectorAll('#site-main > .shopify-section')];
      ids.forEach((id) => {
        const section = sections.find((node) => node.id.endsWith('__' + id));
        if (section && target) target.append(section);
      });
      panel.hidden = !target?.children.length;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', group, { once: true });
  else group();
  document.addEventListener('shopify:section:load', group);
})();
  } catch(e) { console.error(e); }
})();

})();
